import { Constants } from "@eagerdog/constants";

/**
 * Result-type predicates shared across show types.
 */

/** Non-qualifying results don't require time/deductions. */
export const isNonQualifyingResult = (resultType?: string): boolean => {
  if (!resultType) return false;
  return [
    Constants.score_result_type.absent,
    Constants.score_result_type.bitch_in_season,
    Constants.score_result_type.disqualified,
    Constants.score_result_type.excused,
  ].includes(resultType);
};

export const isScratchResult = (resultType?: string): boolean =>
  resultType === Constants.score_result_type.scratched;

export const isConflictResult = (resultType?: string): boolean =>
  resultType === Constants.score_result_type.conflict;

export const isQualifiedResult = (resultType?: string): boolean =>
  resultType === Constants.score_result_type.qualified;

/**
 * Whether a results object (single or scentwork array) represents a scratch.
 */
export const resultsAreScratch = (
  results: any,
  isMultiResult?: boolean
): boolean => {
  if (isMultiResult && Array.isArray(results)) {
    return results.some((r) => isScratchResult(r?.result_type));
  }
  return isScratchResult(results?.result_type);
};

/**
 * Whether a results object (single or scentwork array) represents a conflict.
 */
export const resultsAreConflict = (
  results: any,
  isMultiResult?: boolean
): boolean => {
  if (isMultiResult && Array.isArray(results)) {
    return results.some((r) => isConflictResult(r?.result_type));
  }
  return isConflictResult(results?.result_type);
};
